/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prettier/prettier */
import { navigate } from 'gatsby-link';
import React, { useState, useEffect } from 'react';
import CategoriesData from '../../glu/atoms/new-glu-client-pages/data';

// eslint-disable-next-line react/prop-types
function GluCategories() {
	const [isScrolled, setIsScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 10) {
				setIsScrolled(true);
			} else {
				setIsScrolled(false);
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<div>
			<div
				className="mt-[52px] xs:mt-[52px] md:mt-72 bg-white sticky glu2xl:mt-12 z-50 w-full max-m-w-screen mx-auto"
				style={{
					position: 'relative',
					zIndex: 50,
					boxShadow: isScrolled
						? '0px 4px 6px rgba(0, 0, 0, 0.1)'
						: 'none',
				}}
			>
				{/* <h2 className=" text-center items-center text-2xl glu2xl:text-2xl glumd:text-2xl gluxs:text-lg">
					Categories
				</h2> */}
				<div className="gluxs:overflow-x-scroll carousel-hide-scrollbar glu2xl:pb-2 justify-start glu2xl:justify-center glulg:ml-40 glu2xl:ml-0 ml-0 glu2xl:w-[78%] w-full flex gap-5 mt-5 text-center glu2xl:gap-3 gluxs:gap-2">
					{CategoriesData.map((category) => (
						<div
							key={category.title}
							className="flex gap-0 text-center items-center justify-center glu2xl:text-center flex-col glu2xl:gap-2"
						>
							<div
								className="cursor-pointer p-1 glu-cards flex flex-col grow items-center"
								role="button"
								tabIndex="0"
								onClick={() => navigate(category.link)}
								onKeyDown={(e) => {
									if (e.key === 'Enter' || e.key === ' ') {
										navigate(category.link);
									}
								}}
							>
								<div
									className="flex items-center justify-center transition-all duration-300 w-20 h-20 gluxs:w-16 gluxs:h-20 glu2xl:w-[90px] glu2xl:h-[110px]"
									style={{
										transition: 'all 0.3s ease-in-out',
									}}
								>
									<img
										src={category.image}
										alt={category.title}
										className="object-contain object-center"
										style={{
											width: '100%',
											height: '100%',
										}}
									/>
								</div>
								<div>
									<p
										className="text-[11px] md:text-lg text-nowrap"
										style={{
											transition: 'all 0.3s ease-in-out',
										}}
									>
										{category.title}
									</p>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default GluCategories;
